var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "repeat-option-set repeat-option-set--weekly" },
    [
      _c("span", { staticClass: "repeat-option-set-section__title" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "on")) + "\n\t")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "repeat-option-set-section__grid" },
        _vm._l(_vm.options, function(option) {
          return _c(
            "button",
            {
              key: option.value,
              staticClass: "repeat-option-set-section-grid-item",
              class: { primary: option.selected },
              on: {
                click: function($event) {
                  return _vm.toggleByDay(option.value)
                }
              }
            },
            [_vm._v("\n\t\t\t" + _vm._s(option.label) + "\n\t\t")]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }